import { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const CollectionReports = () => {
	const { getCollectionReport, collectionReport, collectionReportLoad, getDate, getBill, setViewBillModal, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const walletRef = useRef(null);
	const creditCollectionRef = useRef(null);
	const collectionRef = useRef(null);
	const expenseRef = useRef(null);
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			getCollectionReport(start, end);
			setDateRange(`from_${start}_to_${end}`);
		}
	}

	const formatExcelWallet = () => {
		if (collectionReport !== undefined && collectionReport.wallet_values !== undefined && Object.keys(collectionReport.wallet_values).length > 0) {
			let data = [];
			Object.keys(collectionReport.wallet_values).map(item => {
				data.push({
					'Date': collectionReport.wallet_values[item].collected_date,
					'Customer': collectionReport.wallet_values[item].customer_name,
					'Phone': collectionReport.wallet_values[item].customer_phone,
					'Staff name': collectionReport.wallet_values[item].cash_collected,
					'Amount': collectionReport.wallet_values[item].amount,
				});
			});
			return data;
		}
	}
	const formatExcelCreditCollection = () => {
		if (collectionReport !== undefined && collectionReport.debit_values !== undefined && Object.keys(collectionReport.debit_values).length > 0) {
			let data = [];
			Object.keys(collectionReport.debit_values).map(item => {
				data.push({
					'Date': collectionReport.debit_values[item].collected_date,
					'Invoice No': collectionReport.debit_values[item].bill_no,
					'Customer': collectionReport.debit_values[item].customer_name,
					'Phone': collectionReport.debit_values[item].customer_phone,
					'Staff name': collectionReport.debit_values[item].cash_collected,
					'Amount': collectionReport.debit_values[item].debit_total,
				});
			});
			return data;
		}
	}
	const formatExcelCollection = () => {
		if (collectionReport !== undefined && collectionReport.bill_values !== undefined && Object.keys(collectionReport.bill_values).length > 0) {
			let data = [];
			Object.keys(collectionReport.bill_values).map(item => {
				data.push({
					'Date': collectionReport.bill_values[item].created_date,
					'Invoice No': collectionReport.bill_values[item].bill_no,
					'Token No': collectionReport.bill_values[item].token_no,
					'Customer': collectionReport.bill_values[item].customer_name,
					'Phone': collectionReport.bill_values[item].customer_phone,
					'Created by': collectionReport.bill_values[item].token_created_by,
					'Processed by': collectionReport.bill_values[item].token_processed_by,
					'SC': collectionReport.bill_values[item].service_bill_total,
					'TC': collectionReport.bill_values[item].transaction_bill_total,
					'Total Amount': collectionReport.bill_values[item].bill_total,
				});
			});
			return data;
		}
	}
	const formatExcelExpense = () => {
		if (collectionReport !== undefined && collectionReport.expense_values !== undefined && Object.keys(collectionReport.expense_values).length > 0) {
			let data = [];
			Object.keys(collectionReport.expense_values).map(item => {
				data.push({
					'Date': collectionReport.expense_values[item].date,
					'Particulars': collectionReport.expense_values[item].particulars,
					'Remarks': collectionReport.expense_values[item].remarks,
					'Staff name': collectionReport.expense_values[item].user,
					'Expense Type': collectionReport.expense_values[item].petti_cash ? 'Petty Expense' : 'Expense',
					'Payment Method': collectionReport.expense_values[item].payment_type,
					'Amount': collectionReport.expense_values[item].expense_total,
				});
			});
			return data;
		}
	}
	return (
		<div className="container-fluid" >
			<div className='flex-wrap align-items-center justify-content-between bgp p-2 br-3' >
				<div className="d-grid px-2">
					{
						collectionReportLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>

						) : (
							<span className="tp2 text-white" >Collection Report</span>
						)
					}
				</div>
				<Form onSubmit={getReport} className="d-grid align-items-center justify-content-end" >
					<Row className="flex-wrap align-items-center justify-content-end" >
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				collectionReport !== undefined && collectionReport.wallet_values !== undefined ? (
					<div className='d-grid'>
						<div className='flex-wrap align-items-center justify-content-between' >
							<span className="d-grid f20 px-2 tp2 py-2" ><b>Wallet details</b></span>
							<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
								<span>Download</span>
								<Button className="br-1" onClick={() => {
									downloadExcel(formatExcelWallet(), `report_wallet_details_${dateRange}.xlsx`);
								}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
								<Button onClick={() => {
									generatePDF(walletRef, { filename: `report_wallet_details_${dateRange}.pdf` });
								}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
								<ReactToPrint
									trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
									content={() => walletRef.current}
								/>
							</div>
						</div>
						<Table bordered className="tbl-bg-blue" ref={walletRef} >
							<thead>
								<tr>
									<th>Date</th>
									<th>Customer</th>
									<th>Staff</th>
									<th className='text-end' >Payment</th>
									<th className="text-end" >Total</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(collectionReport.wallet_values).length > 0 ? (
										Object.keys(collectionReport.wallet_values).map((wc, wci) => (
											<tr key={`wc_$wci`} className="tp2" >
												<td>
													<div className='d-grid'>
														<span className="tp2 " >{collectionReport.wallet_values[wc].collected_date}</span>
														<span className="tp2 f14" >{collectionReport.wallet_values[wc].collected_time}</span>
													</div>
												</td>
												<td>
													<div className="d-grid">
														<span className="tp2 " >{collectionReport.wallet_values[wc].customer_name}</span>
														<span className="tp2 f14" >{collectionReport.wallet_values[wc].customer_phone}</span>
													</div>
												</td>
												<td><span className="tp2 " >{collectionReport.wallet_values[wc].cash_collected}</span></td>
												<td>
													<div className="d-grid">
														{
															collectionReport.wallet_values[wc].ap_payments !== undefined ? (
																Object.keys(collectionReport.wallet_values[wc].ap_payments).length > 0 ? (
																	Object.keys(collectionReport.wallet_values[wc].ap_payments).map((b_pay, b_pay_i) => (
																		<div className="grid8by2 align-items-center justify-content-between py-1 bdr2-b" key={`bpay_${b_pay_i}`} >
																			<span className="tp2 f14" >{collectionReport.wallet_values[wc].ap_payments[b_pay].name}</span>
																			<div className='d-flex align-items-center justify-content-end' >
																				<span className="tp2 f14" >{parseFloat(collectionReport.wallet_values[wc].ap_payments[b_pay].amount).toFixed(2)}</span>
																			</div>
																		</div>
																	))
																) : ''
															) : ''
														}
													</div>
												</td>
												<td className="text-end" >
													{
														collectionReport.wallet_values[wc].amount > 0 ? (
															<span className="text-end text-success">{parseFloat(collectionReport.wallet_values[wc].amount).toFixed(2)}</span>
														) : (
															<span className="text-end text-danger">{parseFloat(collectionReport.wallet_values[wc].amount).toFixed(2)}</span>
														)
													}
												</td>
											</tr>
										))
									) : 'Wallet Not found!'
								}
								{
									collectionReport !== undefined ? (
										collectionReport.main !== undefined ? (
											<tr>
												<td colSpan={3} className="bgy text-end" ><span className="tp2 f20" >Total</span></td>
												<td className="bgy" >
													{
														collectionReport.main.advance_total !== undefined ? (
															Object.keys(collectionReport.main.advance_total).length > 0 ? (
																Object.keys(collectionReport.main.advance_total).map((r_pay, r_pay_i) => (
																	collectionReport.main.advance_total[r_pay].amount !== 0 ? (
																		<div key={`r_pay_x${r_pay_i}`} className='grid6by4 align-items-center justify-content-between bdr0-b py-1' >
																			<span className="tp2 " >{collectionReport.main.advance_total[r_pay].name}</span>
																			<div className="d-flex align-items-center justify-content-end" >
																				{
																					collectionReport.main.advance_total[r_pay].amount > 0 ? (
																						<span className="text-end text-success">+{parseFloat(collectionReport.main.advance_total[r_pay].amount).toFixed(2)}</span>
																					) : (
																						<span className="text-end text-danger">-{parseFloat(collectionReport.main.advance_total[r_pay].amount).toFixed(2)}</span>
																					)
																				}
																			</div>
																		</div>
																	) : ''
																))
															) : ''
														) : ''
													}
												</td>
												<td className="text-end bgy" ><span className="tp2 f20" >{parseFloat(collectionReport.main.advance_day_total).toFixed(2)}</span></td>
											</tr>
										) : ''
									) : ''
								}
							</tbody>
						</Table>
					</div>
				) : 'Wallet Not found!'
			}
			{
				collectionReport !== undefined ? (
					collectionReport.debit_values !== undefined && Object.keys(collectionReport.debit_values).length > 0 ? (
						<div className='d-grid'>
							<div className='flex-wrap align-items-center justify-content-between' >
								<span className="d-grid f20 px-2 tp2 py-2" ><b>Credit collection details</b></span>
								<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
									<span>Download</span>
									<Button className="br-1" onClick={() => {
										downloadExcel(formatExcelCreditCollection(), `report_credit_collection_details_${dateRange}.xlsx`);
									}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
									<Button onClick={() => {
										$('.view-bill-link').addClass('hide');
										generatePDF(creditCollectionRef, { filename: `report_credit_collection_details_${dateRange}.pdf` });
										$('.view-bill-link').removeClass('hide');
									}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
									<ReactToPrint
										trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
										content={() => creditCollectionRef.current}
										onBeforeGetContent={() => {
											return new Promise((resolve) => {
												$('.view-bill-link').addClass('hide');
												resolve();
											});
										}}
										onAfterPrint={() => {
											$('.view-bill-link').removeClass('hide');
										}}
									/>
								</div>
							</div>
							<Table bordered className="tbl-bg-blue" ref={creditCollectionRef} >
								<thead>
									<tr>
										<th>Bill details</th>
										<th>Customer</th>
										<th>Staff</th>
										<th className='text-end' >Payment</th>
										<th className="text-end" >Total</th>
									</tr>
								</thead>
								<tbody>
									{
										Object.keys(collectionReport.debit_values).map((debit, deb_i) => (
											<tr key={`debi_${deb_i}`} >
												<td>
													<div className='d-grid'>
														<div className='d-flex align-items-center justify-content-between' >
															<span onClick={() => {
																getBill(collectionReport.debit_values[debit].bill_no);
																setViewBillModal(true);
															}} className="view-bill-link" ><i className="bi bi-receipt" ></i> Bill</span>
														</div>
														<span className="tp2 " >Invoice : {collectionReport.debit_values[debit].bill_no} </span>
														<span className="tp2 f14" >{collectionReport.debit_values[debit].date}</span>
													</div>
												</td>
												<td>
													<div className="d-grid">
														<span className="tp2 " >{collectionReport.debit_values[debit].customer_name}</span>
														<span className="tp2 f14" >{collectionReport.debit_values[debit].customer_phone}</span>
													</div>
												</td>
												<td>{collectionReport.debit_values[debit].cash_collected}</td>
												<td>
													<div className="d-grid">
														{
															collectionReport.debit_values[debit].debit_payments !== undefined ? (
																Object.keys(collectionReport.debit_values[debit].debit_payments).length > 0 ? (
																	Object.keys(collectionReport.debit_values[debit].debit_payments).map((b_pay, b_pay_i) => (
																		<div className="grid8by2 align-items-center justify-content-between" key={`bpay_${b_pay_i}`} >
																			<span className="tp2 f14" >{collectionReport.debit_values[debit].debit_payments[b_pay].name}</span>
																			<div className='d-flex align-items-center justify-content-end' >
																				<span className="tp2 f14" >{parseFloat(collectionReport.debit_values[debit].debit_payments[b_pay].amount).toFixed(2)}</span>
																			</div>
																		</div>
																	))
																) : ''
															) : ''
														}
													</div>
												</td>
												<td className="text-end pos-rel" >
													<span className="tp2" >{parseFloat(collectionReport.debit_values[debit].debit_total).toFixed(2)}</span>
												</td>
											</tr>
										))
									}
									{
										collectionReport !== undefined ? (
											collectionReport.main !== undefined ? (
												<tr>
													<td colSpan={3} className="text-end bgy" ><span className="tp2 f20" >Total</span></td>
													<td className="bgy" >
														{
															collectionReport.main.debit_total !== undefined ? (
																Object.keys(collectionReport.main.debit_total).length > 0 ? (
																	Object.keys(collectionReport.main.debit_total).map((r_pay, r_pay_i) => (
																		collectionReport.main.debit_total[r_pay].amount > 0 ? (
																			<div key={`r_pay_${r_pay_i}`} className='grid6by4 align-items-center justify-content-between bdr0-b py-1' >
																				<span className="tp2 " >{collectionReport.main.debit_total[r_pay].name}</span>
																				<div className='d-flex align-items-center justify-content-end' >
																					<span className="tp2 f14" >{parseFloat(collectionReport.main.debit_total[r_pay].amount).toFixed(2)}</span>
																				</div>
																			</div>
																		) : ''
																	))
																) : ''
															) : ''
														}
													</td>
													<td className="text-end bgy" ><span className="tp2 f20" >{parseFloat(collectionReport.main.debit_amount_total).toFixed(2)}</span></td>
												</tr>
											) : ''
										) : ''
									}
								</tbody>
							</Table>
						</div>
					) : ''
				) : ''
			}
			<div className='d-grid'>
				<div className='flex-wrap align-items-center justify-content-between' >
					<span className="d-grid f18 tp2 py-2 f20 px-2" ><b>Collection details</b></span>
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcelCollection(), `report_collection_details_${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							$('.view-bill-link').addClass('hide');
							generatePDF(collectionRef, { filename: `report_collection_details_${dateRange}.pdf` });
							$('.view-bill-link').removeClass('hide');
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => collectionRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									$('.view-bill-link').addClass('hide');
									resolve();
								});
							}}
							onAfterPrint={() => {
								$('.view-bill-link').removeClass('hide');
							}}
						/>
					</div>
				</div>
				<Table bordered className="tbl-bg-blue" ref={collectionRef} >
					<thead>
						<tr>
							<th>Bill details</th>
							<th>Services</th>
							<th>Customer</th>
							<th className='text-end' >Times</th>
							<th className='text-end' >Payment</th>
							<th className="text-end" >TC</th>
							<th className="text-end" >SC</th>
							<th className="text-end" >Total</th>
						</tr>
					</thead>
					<tbody>
						{
							collectionReport !== undefined ? (
								collectionReport.bill_values !== undefined ? (
									Object.keys(collectionReport.bill_values).map((tkn, tkn_i) => (
										<tr key={`trep_${tkn_i}`} >
											<td>
												<div className='d-grid'>
													<div className='d-flex'>
														<span onClick={() => {
															getBill(collectionReport.bill_values[tkn].bill_no);
															setViewBillModal(true);
														}} className="view-bill-link" ><i className="bi bi-receipt" ></i> Bill</span>
													</div>
													<span className="tp2 " >Invoice : {collectionReport.bill_values[tkn].bill_no}</span>
													<span className="tp2 f14" >{collectionReport.bill_values[tkn].date}</span>
												</div>
											</td>
											<td>
												<div className="d-grid">
													{
														collectionReport.bill_values[tkn].bill_services !== undefined ? (
															Object.keys(collectionReport.bill_values[tkn].bill_services).length > 0 ? (
																Object.keys(collectionReport.bill_values[tkn].bill_services).map((t_ser, t_ser_i) => (
																	<span className="tp2" key={`tkrpt_${t_ser_i}`} >{collectionReport.bill_values[tkn].bill_services[t_ser].service_name}{collectionReport.bill_values[tkn].bill_services[t_ser].quantity !== undefined && collectionReport.bill_values[tkn].bill_services[t_ser].quantity > 1 ? (<> ({collectionReport.bill_values[tkn].bill_services[t_ser].quantity})</>) : ''}</span>
																))
															) : ''
														) : ''
													}
												</div>
											</td>
											<td>
												<div className="d-grid">
													<span className="tp2 " >{collectionReport.bill_values[tkn].customer_name}</span>
													<span className="tp2 f14" >{collectionReport.bill_values[tkn].customer_phone}</span>
												</div>
											</td>
											<td>
												<div className="d-grid">
													<div className="grid6by4 align-items-center justify-content-between">
														<span className="tp2 f14" >Created - {collectionReport.bill_values[tkn].token_created_by}</span>
														<div className='d-flex align-items-center justify-content-end' >
															<span className="tp2 f14" >{collectionReport.bill_values[tkn].created_time}</span>
														</div>
													</div>
													<div className="grid6by4 align-items-center justify-content-between">
														<span className="tp2 f14" >Processed - {collectionReport.bill_values[tkn].token_processed_by}</span>
														<div className='d-flex align-items-center justify-content-end' >
															<span className="tp2 f14" >{collectionReport.bill_values[tkn].open_time}</span>
														</div>
													</div>
													<div className="grid6by4 align-items-center justify-content-between">
														<span className="tp2 f14" >Closed - {collectionReport.bill_values[tkn].token_processed_by}</span>
														<div className='d-flex align-items-center justify-content-end' >
															<span className="tp2 f14" >{collectionReport.bill_values[tkn].close_time}</span>
														</div>
													</div>
												</div>
											</td>
											<td>
												<div className="d-grid">
													{
														collectionReport.bill_values[tkn].bill_payments !== undefined ? (
															Object.keys(collectionReport.bill_values[tkn].bill_payments).length > 0 ? (
																Object.keys(collectionReport.bill_values[tkn].bill_payments).map((b_pay, b_pay_i) => (
																	<div className="grid6by4 align-items-center justify-content-between bdr2-b py-1" key={`bpay_${b_pay_i}`} >
																		<span className="tp2 f14" >{collectionReport.bill_values[tkn].bill_payments[b_pay].name}</span>
																		<div className='d-flex align-items-center justify-content-end' >
																			<span className="tp2 f14" >{parseFloat(collectionReport.bill_values[tkn].bill_payments[b_pay].amount).toFixed(2)}</span>
																		</div>
																	</div>
																))
															) : ''
														) : ''
													}
												</div>
											</td>

											<td className="text-end pos-rel" >
												<span className="tp2" >{parseFloat(collectionReport.bill_values[tkn].transaction_bill_total).toFixed(2)}</span>
											</td>
											<td className="text-end pos-rel" >
												<span className="tp2" >{parseFloat(collectionReport.bill_values[tkn].service_bill_total).toFixed(2)}</span>
											</td>
											<td className="text-end pos-rel" >
												<span className="tp2" >{parseFloat(collectionReport.bill_values[tkn].bill_total).toFixed(2)}</span>
											</td>
										</tr>
									))
								) : ''
							) : ''
						}
						{
							collectionReport !== undefined ? (
								collectionReport.main !== undefined ? (
									<tr>
										<td colSpan={3} className="bgy"  ></td>
										<td className="text-end bgy" ><span className='f18 tp2'>Total</span></td>
										<td className="bgy">
											{
												collectionReport.main.payments_total !== undefined ? (
													Object.keys(collectionReport.main.payments_total).length > 0 ? (
														Object.keys(collectionReport.main.payments_total).map((r_pay, r_pay_i) => (
															collectionReport.main.payments_total[r_pay].amount > 0 ? (
																<div className='grid8by2 align-items-center justify-content-between bdr0-b py-1' key={`r_pay_${r_pay_i}`} >
																	<span className="tp2 f14" >{collectionReport.main.payments_total[r_pay].name}</span>
																	<div className='d-flex align-items-center justify-content-end' >
																		<span className="tp2 f14" >{parseFloat(collectionReport.main.payments_total[r_pay].amount).toFixed(2)}</span>
																	</div>
																</div>
															) : ''
														))
													) : ''
												) : ''
											}
										</td>
										<td className="text-end bgy" ><span className='f18 tp2'>{parseFloat(collectionReport.main.transaction_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy" ><span className='f18 tp2'>{parseFloat(collectionReport.main.service_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy" ><span className='f18 tp2'>{parseFloat(collectionReport.main.bill_amount_total).toFixed(2)}</span></td>
									</tr>
								) : ''
							) : ''
						}
					</tbody>
				</Table>
			</div>

			{
				collectionReport !== undefined && collectionReport.expense_values !== undefined && Object.keys(collectionReport.expense_values).length > 0 ? (
					<div className='d-grid'>
						<div className='flex-wrap align-items-center justify-content-between' >
							<span className="d-grid f20 px-2 tp2 py-2" ><b>Expense details</b></span>
							<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
								<span>Download</span>
								<Button className="br-1" onClick={() => {
									downloadExcel(formatExcelExpense(), `report_credit_collection_details_${dateRange}.xlsx`);
								}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
								<Button onClick={() => {
									$('.view-bill-link').addClass('hide');
									generatePDF(expenseRef, { filename: `report_credit_collection_details_${dateRange}.pdf` });
									$('.view-bill-link').removeClass('hide');
								}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
								<ReactToPrint
									trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
									content={() => expenseRef.current}
									onBeforeGetContent={() => {
										return new Promise((resolve) => {
											$('.view-bill-link').addClass('hide');
											resolve();
										});
									}}
									onAfterPrint={() => {
										$('.view-bill-link').removeClass('hide');
									}}
								/>
							</div>
						</div>
						<Table bordered className="tbl-bg-blue" ref={expenseRef}  >
							<thead>
								<tr>
									<th className="tp2" >Date</th>
									<th className="tp2" >Particulars</th>
									<th className="tp2" >Remarks</th>
									<th className="tp2" >Staff</th>
									<th className="tp2" >Expense Type</th>
									<th className="tp2" >Payment method</th>
									<th className="text-end tp2" >Amount</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(collectionReport.expense_values).map((exp, expi) => (
										<tr key={`expi_${expi}`} className="tc2" >
											<td>{collectionReport.expense_values[exp].date}</td>
											<td>
												<span className="d-grid" >{collectionReport.expense_values[exp].particulars}</span>
											</td>
											<td>{collectionReport.expense_values[exp].remarks}</td>
											<td>{collectionReport.expense_values[exp].user}</td>
											<td>{collectionReport.expense_values[exp].petti_cash ? 'Petty Expense' : 'Expense'}</td>
											<td>
												{
													collectionReport.expense_values[exp].expense_payments !== undefined && Object.keys(collectionReport.expense_values[exp].expense_payments).length > 0 ? (
														Object.keys(collectionReport.expense_values[exp].expense_payments).map((b_pay, b_pay_i) => (
															<div key={`bpay_${b_pay_i}`} className="grid8by2 align-items-center justify-content-between mb-1 px-1" >
																<span className="tp2" >{collectionReport.expense_values[exp].expense_payments[b_pay].name}</span>
																<div className="d-flex align-items-center justify-content-end" >
																	<span className="tp2" >{parseFloat(collectionReport.expense_values[exp].expense_payments[b_pay].amount).toFixed(2)}</span>
																</div>
															</div>
														))
													) : ''
												}
											</td>
											<td className="text-end">{parseFloat(collectionReport.expense_values[exp].expense_total).toFixed(2)}</td>
										</tr>
									))
								}
								<tr>
									<td colSpan={5} className="text-end bgy"><span className="f20 tp2">Total</span></td>
									<td className="bgy">
										{
											collectionReport.main.expense_total !== undefined && Object.keys(collectionReport.main.expense_total).length > 0 ? (
												Object.keys(collectionReport.main.expense_total).map((ex, exi) => (
													collectionReport.main.expense_total[ex].amount > 0 ? (
														<div className="grid8by2 align-items-center justify-content-between bdr0-b py-1" key={`bpay_${exi}`} >
															<span className="tp2 " >{collectionReport.main.expense_total[ex].name}</span>
															<div className='d-flex align-items-center justify-content-end' >
																<span className="tp2 " >{parseFloat(collectionReport.main.expense_total[ex].amount).toFixed(2)}</span>
															</div>
														</div>
													) : ''
												))
											) : ''
										}
									</td>
									<td className="text-end bgy"><span className="tp2 f20">{collectionReport.main !== undefined ? parseFloat(collectionReport.main.expense_day_total).toFixed(2) : ''}</span></td>
								</tr>
							</tbody>
						</Table>
					</div>
				) : ''
			}
		</div>
	)
}